<template>
    <div class="p-5 upgrade-success">
        <img src="@/assets/images/setup/success.svg" alt="Success" class="d-block mx-auto mb-4">
        <h1 class="text-center mb-4">Payment Sucess!</h1>
        <p class="text-center mb-4">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eaque quaerat velit mollitia quo ipsa. Obcaecati repellat natus sed saepe molestias nemo iure, ipsum reprehenderit, iusto commodi laborum fugiat a debitis!</p>
        <b-button variant="primary" class="mx-auto py-3 d-block" :to="'/'">
            Back to Home
        </b-button>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
};
</script>
<style lang="scss">
h1 {
    font-size: 30px;
}
p {
    font-size: 12px;
    color: #33363A;
}
.btn-primary {
    width: 183px;
    font-size: 18px;
}
</style>